"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _SpacerComponent.default;
  }
});

var _SpacerComponent = _interopRequireDefault(require("./Spacer-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }